module.exports = __webpack_public_path__ + "static/media/HomeGraphic4.71b7c886.jpg";